import { render, staticRenderFns } from "./SilomAlert.vue?vue&type=template&id=e461ead0&scoped=true"
import script from "./SilomAlert.vue?vue&type=script&lang=js"
export * from "./SilomAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e461ead0",
  null
  
)

export default component.exports